var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"heart-wrapper",class:{'active':_vm.status},on:{"click":_vm.handleClick}},[_c('i',{staticClass:"fa fa-heart"}),_vm._v("点赞 "+_vm._s(_vm.value))])}
var staticRenderFns = []

export { render, staticRenderFns }